<template>
  <StepLayout
    :key="steps[currentStep]"
    :title="$t('admin.tasks.label', 2)"
    :count="item.tasks_open + item.tasks_scheduled"
    :showBack="true"
    class="flex flex-col px-6 py-4 gap-1"
    @back="emit('back')"
  >
    <template #button="{ isMobile }">
      <ActionButton
        :variant="variant"
        :hide="!variant"
        :buildingId="building.id"
        :isMobile="isMobile"
        @clear="clear"
        @goToStep="handleGoToStep"
      />
    </template>
    <Component
      ref="componentRef"
      :is="steps[currentStep]?.content"
      v-bind="steps[currentStep]?.props"
      @back="handleStepBack"
    />
  </StepLayout>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { ActionButton, StepLayout } from "@/SharedComponents/Passport";
import { TaskList } from "@/SharedComponents/Passport/Steps/Tasks";
import { useSteps, Steps } from "@/Composables/useSteps";

// Define Emits
const emit = defineEmits(["back"]);

// Define Props
const props = defineProps({
  item: { type: Object, required: true },
  filter: { type: Object, required: true },
  building: { type: Object, required: true },
});

// Refs
const componentRef = ref(null);

const steps = computed(
  () =>
    new Steps({
      overview: {
        content: TaskList,
        props: {
          item: props.item,
          filter: props.filter,
          withBackdropButton: true,
        },
      },
    })
);

const { currentStep, handleStepBack, handleGoToStep, reset } = useSteps(
  steps.value
);

const variant = computed(() => {
  return null;
  //   switch (currentStep.value) {
  //     case "overview":
  //       return "add-task";
  //     default:
  //       return null;
  //   }
});

const editing = ref(false);

const isDirty = computed(() => componentRef.value?.isDirty);

defineExpose({
  editing,
  isDirty,
  cancel: () => componentRef.value?.cancel(),
  submit: () => componentRef.value?.submit(),
});

onMounted(() => {
  reset();
});
</script>
